spec_version: "1.1"

# Identidad del curso
id: mentor-wallet
slug: mentor-wallet
tipo_curso: suscripcion-progresiva
nombre: "Ruta financiera personalizada"
nombre_corto: "Tu ruta"
descripcion_corta: "Tu itinerario de educación financiera adaptado a tu perfil. 6 módulos con píldoras, calculadoras interactivas y herramientas prácticas para tomar mejores decisiones con tu dinero."
idioma: es-ES
duracion_total_min: 600
audiencia: "Adultos con interés en educación financiera personal, desde principiantes hasta inversores autodidactas"
editor: "MentorWallet"
version_curso: "0.1.0"
fecha_publicacion: "2026-06-15"

# Categorías para el catálogo
categorias:
  - finanzas-personales
  - educacion

# Modalidad
modalidad_predominante: mixto   # markdown | video | mixto

# Branding del tenant MentorWallet (sobreescribe el branding de PV-Learn)
branding:
  color_primario: "#8D3AED"     # púrpura MW
  color_acento: "#FC90A7"       # rosa MW
  gradiente: ["#8D3AED", "#FC90A7"]
  logo_claro: ""                # pendiente de coordinar con diseñador
  logo_oscuro: ""               # pendiente
  favicon: ""                   # pendiente
  fuente_titulares: "Bricolage Grotesque"
  fuente_cuerpo: "Instrument Sans"

# Reglas de avance del alumno
criterios_finalizacion_modulo:
  teoria_scroll_pct_min: 80
  video_visto_pct_min: 80
  audio_escuchado_pct_min: 80

# Modo de navegación
#
# En MentorWallet la ruta es personalizada por perfil (8 perfiles
# resultantes del diagnóstico). El motor de "ruta personalizada" se
# implementa en el bloque 4 del roadmap MW. Mientras tanto, "libre"
# permite que el alumno acceda a cualquier módulo en cualquier orden,
# con recomendaciones blandas via checklist de prerequisitos.
modo_navegacion: "libre"

# Prerrequisitos formales (informativo)
prerrequisitos_formales:
  - "Ninguno. El diagnóstico inicial clasifica al usuario y adapta la ruta."

# Orden por defecto de los módulos. La ruta real para cada usuario se
# decide por el motor de aprendizaje personalizado según el perfil
# detectado en el diagnóstico.
modulos:
  - 01-diagnostico-y-base
  - 02-fondo-de-emergencia
  - 03-eliminacion-de-deudas
  - 04-ahorro-automatizado
  - 05-inversion-largo-plazo
  - 06-optimizacion-fiscal
